"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/fetch`;
    }
    /**
     * Returns time-value data aggregations filtered by parameters specified
     * HTTP Method: post
     * Endpoint: /analytics/calls/v1/accounts/{accountId}/timeline/fetch
     * Rate Limit Group: Light
     * App Permission: Analytics
     */
    async post(timelineRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), timelineRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map